import React from 'react'
import { useTranslation } from 'react-i18next';
import ManageState from './manageState';
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import StateComponents from '../../../components/state-component/StateComponents';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import ContainerButton from '../../../components/button/ContainerButton';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';

export default function ManageRequest() {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

        status,
        set_status,
        handleSubmit,
        handleDownloadReport,
        checkPermit
    } = ManageState()
    const navigate = useNavigate()

    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("จัดการข้อมูลคำร้อง")}
                navigateContent={<NavigateListCustom
                    navigateData={[
                        {
                            key: "complaintSubmit",
                            name: t("ระบบคำร้อง"),
                            disabled_match: true,
                            pathName: routeName.request_form.manage_request_forms
                        },
                        {
                            key: "complaintSubmit",
                            name: t("จัดการข้อมูลคำร้อง"),
                            pathName: routeName.request_form.manage_request_forms
                        },

                    ]}
                />}
                buttonContent={<ContainerButton
                    // sxContainer={{ my: 3 }}
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            seq: 1,
                            hidden: !checkPermit?.isView,
                            buttonProps: {
                                onClick: () => { handleDownloadReport('excel') },
                            },
                            key: "DOWNLOAD_CSV",
                            label: t("ดาวน์โหลด CSV"),
                            type: 'DOWNLOAD_CSV'
                        },
                        {
                            seq: 2,
                            hidden: !checkPermit?.isView,
                            buttonProps: {
                                onClick: () => {
                                    //   setShowModal('REJECT')
                                    // handleSubmit()
                                    handleDownloadReport('pdf')
                                }
                            },
                            key: "DOWNLOAD_PDF",
                            label: t("ดาวน์โหลด PDF"),
                            type: 'DOWNLOAD_PDF'
                        },
                        {
                            seq: 2,
                            hidden: !checkPermit?.isUpdate,
                            buttonProps: {
                                onClick: () => {
                                    //   alertActive(t("LIST_APPLICANTS_APPROVED"), t("LIST_APPLICANTS_CONFIRM_DECISION"), undefined, undefined, async () => {
                                    //     handleSent()
                                    //   })
                                    handleSubmit()
                                }
                            },
                            key: "APPROVE2",
                            label: t("รับเรื่อง"),
                            type: 'APPROVE2'
                        },
                    ]}
                />}

                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("ค้นหา"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                // {
                                //     seq: 1,
                                //     type: "SELECT",
                                //     gridProps: {
                                //         xs: 12,
                                //         md: 3
                                //     },
                                //     fieldProps: {
                                //         labelId: "ss",
                                //         heading: "",
                                //         onChange: (e) => {
                                //             // handleChange('form_type', index, e.target.value);
                                //             // set_id_degree(e.target.value)
                                //         },
                                //         options: [{
                                //             label: t('LIST_APPLICANTS_ALL_LEVELS'),
                                //             value: "ALL",
                                //         },
                                //             // ...degree?.map((item: any) => {
                                //             //     return {
                                //             //         label: item?.degree_name,
                                //             //         value: item?.id_degree,
                                //             //     }
                                //             // })
                                //         ],
                                //         selectId: "",
                                //         value: '',
                                //     }
                                // },

                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("LIST_APPLICANTS_DATE_RANGE")
                                    }
                                },
                                // {
                                //     seq: 3,
                                //     type: "SELECT",
                                //     gridProps: {
                                //         xs: 12,
                                //         md: 3
                                //     },
                                //     fieldProps: {
                                //         labelId: "ss",
                                //         heading: "",
                                //         onChange: (e) => {
                                //             // handleChange('form_type', index, e.target.value);
                                //             // set_id_degree(e.target.value)
                                //         },
                                //         options: [{
                                //             label: t('LIST_APPLICANTS_ALL_LEVELS'),
                                //             value: "ALL",
                                //         },
                                //             // ...degree?.map((item: any) => {
                                //             //     return {
                                //             //         label: item?.degree_name,
                                //             //         value: item?.id_degree,
                                //             //     }
                                //             // })
                                //         ],
                                //         selectId: "",
                                //         value: '',
                                //     }
                                // },
                                // {
                                //     seq: 4,
                                //     type: "SELECT",
                                //     gridProps: {
                                //         xs: 12,
                                //         md: 5
                                //     },
                                //     fieldProps: {
                                //         labelId: "ss",
                                //         heading: "",
                                //         onChange: (e) => {
                                //             // handleChange('form_type', index, e.target.value);
                                //             // set_id_degree(e.target.value)
                                //         },
                                //         options: [{
                                //             label: t('LIST_APPLICANTS_ALL_LEVELS'),
                                //             value: "ALL",
                                //         },
                                //             // ...degree?.map((item: any) => {
                                //             //     return {
                                //             //         label: item?.degree_name,
                                //             //         value: item?.id_degree,
                                //             //     }
                                //             // })
                                //         ],
                                //         selectId: "",
                                //         value: '',
                                //     }
                                // },



                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

        </div>
    )
}
